import { PocBackdrop } from 'commons/components/components-wrapper/poc-backdrop.component';
import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { LayoutModuleStyled } from './module.layout.style';

export interface ModuleLayoutProps extends React.PropsWithChildren {
    isPageLoading?: boolean;
}

export const ModuleLayout: React.FC<ModuleLayoutProps> = (props) => {
    const { children, isPageLoading = false } = props;

    const defaultOpacity: number = 0.5;

    return (
        <LayoutModuleStyled>
            <PocBackdrop disableScrollLock opacity={defaultOpacity} hidden={!isPageLoading}>
                <PocProgressSpinner variant="primary" size="large" />
            </PocBackdrop>
            {children}
        </LayoutModuleStyled>
    );
};
